import type { ReactNode } from 'react';

import { cn } from '../../lib/utils';
import { Stack } from '@folio/components/ui/flex';
import { Text, Title } from '@folio/components/ui/text';

interface FunnelStepHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  className?: string;
}

export function FunnelStepHeader({ title, subtitle, className }: FunnelStepHeaderProps) {
  return (
    <Stack className={cn('gap-2', className)}>
      <Title order={2} size="2xl" className="tracking-tight font-bold">
        {title}
      </Title>
      {subtitle && (
        <Text size="sm" tone="muted">
          {subtitle}
        </Text>
      )}
    </Stack>
  );
}
